import { createFileRoute, Link } from "@tanstack/react-router";
import { CountryPage, ratesQueryOptions, historyQueryOptions } from "@/components/CountryPage";
import { FaqSection } from "@/components/FaqSection";
import { SITE_URL, hreflangLinks, faqPageSchema } from "@/lib/seo";

const PATH = "/aaj-ka-sone-ka-bhav";
const TITLE = "Aaj Ka Sone Ka Bhav — Live Sone Ka Rate India (24 Carat, 22 Carat, 18 Carat)";
const DESC = "Aaj ka sone ka bhav live India — 24 carat, 22 carat, 18 carat sone ka rate per 10 gram, 1 gram, 1 tola. Delhi, Mumbai, Chennai, Jaipur, Lucknow, Nagpur — refreshed every 10 minutes.";

const FAQS = [
  { q: "Aaj ka sone ka bhav kya hai India mein?", a: "Aaj India mein sone ka bhav har city ke sarafa bazaar ke hisaab se thoda different hota hai. Delhi, Mumbai, Chennai, Kolkata, Bangalore ka 24 carat aur 22 carat sone ka rate live is page par 10 minute mein update hota hai." },
  { q: "24 carat sone ka bhav aaj ka?", a: "24 carat (99.9% pure) sona bullion aur investment ke liye use hota hai. Aaj ka 24K sone ka bhav per 10 gram live upar table mein hai — international spot + USD/INR ke hisaab se calculate hota hai." },
  { q: "22 carat sone ka bhav aaj ka?", a: "22 carat (91.67% / 916) sona jewellery ke liye standard hai India mein. Aaj ka 22K sone ka bhav per 10 gram, per gram aur per tola live hai — dedicated 22 carat page bhi hai." },
  { q: "1 tola sone ka bhav kitna hai aaj?", a: "1 tola = 11.6638 gram. Aaj ka 1 tola sone ka bhav 24 carat, 22 carat aur 18 carat ke liye live hai — city select karke exact rate dekhein." },
  { q: "Sone ka bhav kab kam hoga?", a: "Sone ka bhav girne ke liye US dollar strong hona chahiye aur international spot ka correction chahiye. Complete forecast analysis ke liye India gold forecast page dekhein." },
  { q: "Live sone ka bhav aur today sone ka bhav mein kya farq hai?", a: "Kuch nahi — dono same hai. 'Live' matlab har 10 minute update ho raha, aur 'today' matlab aaj ki date ka rate." },
];

export const Route = createFileRoute("/aaj-ka-sone-ka-bhav")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: `${SITE_URL}${PATH}` },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(faqPageSchema(FAQS)) }],
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(ratesQueryOptions);
    void context.queryClient.prefetchQuery(historyQueryOptions("india"));
  },
  component: () => (
    <>
      <CountryPage
        country="india"
        title="Aaj Ka Sone Ka Bhav — Live Sone Ka Rate India"
        intro="Aaj ka sone ka bhav India — live 24 carat, 22 carat aur 18 carat sone ka rate top 10 cities (Delhi, Mumbai, Chennai, Kolkata, Bangalore, Hyderabad, Jaipur, Lucknow, Pune, Surat) mein har 10 minute par refresh hota hai. 1 gram, 1 tola, 10 gram aur 1 kilo sone ka bhav ka full breakdown — apne city ka rate direct dekhein aur trend track karein."
        extras={
          <>
            <section className="mx-auto max-w-4xl px-4 pt-6">
              <div className="grid gap-3 sm:grid-cols-3">
                <Link to="/sone-ka-bhav-22-carat" className="rounded-xl border border-border bg-card p-4 hover:border-primary">
                  <div className="font-semibold text-sm">22 carat sone ka bhav</div>
                  <div className="text-xs text-muted-foreground mt-1">Jewellery-grade 916 gold — dedicated page.</div>
                </Link>
                <Link to="/india/gold-forecast" className="rounded-xl border border-border bg-card p-4 hover:border-primary">
                  <div className="font-semibold text-sm">Kya sone ka bhav kam hoga?</div>
                  <div className="text-xs text-muted-foreground mt-1">Live trend & forecast analysis.</div>
                </Link>
                <Link to="/silver-rate-india" className="rounded-xl border border-border bg-card p-4 hover:border-primary">
                  <div className="font-semibold text-sm">Chandi aur sone ka bhav</div>
                  <div className="text-xs text-muted-foreground mt-1">Gold-silver ratio & chandi rate.</div>
                </Link>
              </div>
            </section>
            <FaqSection faqs={FAQS} title="Aaj ka sone ka bhav — FAQs" />
          </>
        }
      />
    </>
  ),
});